import { render, staticRenderFns } from "./BusinessInformationUserInfo.vue?vue&type=template&id=370937a4"
import script from "./BusinessInformationUserInfo.vue?vue&type=script&lang=js"
export * from "./BusinessInformationUserInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports